const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
  controls: 'aria-controls'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );

    const details = document.querySelector('.customer-details');
    const addresses = document.querySelector('.customer-addresses');

    if (target.getAttribute(attributes.controls) === 'AddAddress') {
      addresses.classList.add('hidden');
      details.classList.add('hidden');
      target.classList.add('hidden');
    }

    if (target.classList.contains('button--edit')) {
      target.closest('li').classList.add('current');
      details.classList.add('hidden');
      document.querySelector('.customer-addresses__title').classList.add('hidden');
      target.closest('li').querySelector('.customer-addresses__text').classList.add('hidden');
      document.querySelectorAll('.customer-addresses li:not(.current)').forEach(element => element.classList.add('hidden'));
      document.querySelector('.add-newaddress').classList.add('hidden');
    }

    window.scrollTo(0, 0);
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    );

    const details = document.querySelector('.customer-details');
    const addresses = document.querySelector('.customer-addresses');
    
    if (currentTarget.parentElement.getAttribute('id') == 'AddAddress') {
      details.classList.remove('hidden');
      addresses.classList.remove('hidden');
      document.querySelector('.button-add-address').classList.remove('hidden');
      const newAddressContainer = document.getElementById('new-address');
      newAddressContainer.querySelector('form').reset();
      newAddressContainer.querySelector('form').querySelectorAll('input, select').forEach(element => element.classList.remove('compiled-field'));
    }
    
    if (currentTarget.parentElement.classList.contains('edit-address')) {
      details.classList.remove('hidden')
      document.querySelector('.customer-addresses__title').classList.remove('hidden');
      currentTarget.closest('li').classList.remove('current')
      document.querySelectorAll('.customer-addresses li').forEach(element => element.classList.remove('hidden'))
      document.querySelectorAll('.customer-addresses__text').forEach(element => element.classList.remove('hidden'));
      document.querySelector('.add-newaddress').classList.remove('hidden');
    }
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}
